import _ from "lodash";

const getNewStudentProgressReportPath = ({
  separator,
  checkingIndex,
  pathname,
}) => {
  let newPath = null;

  if (!_.includes(pathname, "student-view")) {
    const routes = _.split(pathname, "/");
    const subArray = _.slice(routes, _.indexOf(routes, separator) + 1);

    if (subArray[checkingIndex]) {
      newPath = _.replace(
        pathname,
        subArray[checkingIndex],
        `student-view/${subArray[checkingIndex]}`
      );
    }
  }

  return newPath;
};

export default store => ({
  path: "*",
  onEnter(nextState, replace) {
    const { location: { pathname } = {} } = nextState;

    let fallbackPath = "/page-not-found";

    /**
     * @description it is handled in handleQueryParameters function
     */
    if (_.includes(pathname, "/sso")) {
      return;
    }
    //Handled old routes. Will remove in the next build
    if (!_.includes(pathname, "/platform")) {
      const newPath = _.replace(pathname, "/teacher", "/home");
      fallbackPath = `/platform${newPath}`;
    } else if (_.includes(pathname, "/reporttasks")) {
      //Admin end SPR
      fallbackPath =
        getNewStudentProgressReportPath({
          pathname,
          separator: "reporttasks",
          checkingIndex: 2,
        }) ?? fallbackPath;
    } else if (_.includes(pathname, "progressreport")) {
      //PYP SPR
      fallbackPath =
        getNewStudentProgressReportPath({
          pathname,
          separator: "progressreport",
          checkingIndex: 1,
        }) ?? fallbackPath;
    } else if (_.includes(pathname, "progress-report-sets")) {
      //MYP UBD SPR
      fallbackPath =
        getNewStudentProgressReportPath({
          pathname,
          separator: "progress-report-sets",
          checkingIndex: 2,
        }) ?? fallbackPath;
    }

    replace(fallbackPath);
  },
});
